import script from "./NoiHoc.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoiHoc.vue?vue&type=script&lang=ts&setup=true"

import "./NoiHoc.vue?vue&type=style&index=0&id=d9352d6c&scoped=true&lang=css"

import exportComponent from "D:\\AppV5\\DangKyXetTuyen\\vueapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9352d6c"]])

export default __exports__